import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Radio, Stack, Typography, useTheme } from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import { counterSaleManagementValueState, listVehiclesReadyState, rentalAgreementFillingValueState, bookingDataValueState, raFillingAccordionValidationState } from "../create-ra/state";

import { raDetailState } from "../ra-detail/state";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";
import { findCounterSaleManagement, listVehiclesReadyToRent, raEdit, fetchCounterSaleManagement } from "../create-ra/services/http.services";
import { useContext, useEffect, useMemo, useState } from "react";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import { fetchRaDetail } from "../ra-detail/services/http.services";
import { FormAutocomplete, FormRadioGroup, FormTextField } from "../common/form-fields-wrappers";
import { ICounterSale, ICSAncillary, IRaEditForm } from "../models/models";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { deepClone } from "../../../util/state/commonFunctions";
import { yupResolver } from "@hookform/resolvers/yup";
import _ from "underscore";
import { getMobilityStoreBySapId } from "../search-dms/dmsSearch.actions";
import { AxiosError } from "axios";
import AncillariesInfoTest from "./ancillaries/AncillariesInfo";
import SectionHeader from "../../../util/component/SectionHeader";
import { formatCurrency, getLocaleByLang } from "../utils";
import { LOCALES } from "../config";
import { RA_EDIT_FORM_VALIDATION_SCHEMA } from "./config";
import { buildSelectedAcrissSipp } from "../create-ra/ra-filling/selectedAcrissSipp";
import CustomLoader from "../../../util/component/CustomLoader";
import { raFillingPricingErrorsManagement } from "../create-ra/ra-filling/utils";


function EditRa() {
  const { t } = useTranslation(['network', 'translation']);
  const theme = useTheme();
  const params = useParams(); // params.id
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [loading, setLoading] = useState(true);
  const [raFilling, setRaFilling] = useRecoilState(rentalAgreementFillingValueState);
  const [listVehiclesReady, setListVehiclesReady] = useRecoilState(listVehiclesReadyState);
  const [selectionCarOptionList, setSelectionCarOptionList] = useState({ acriss: [], sipp: [], plate: [] });
  const [brandModelDescr, setBrandModelDescr] = useState("");

  const [counterSaleManagement, setCounterSaleManagement] = useRecoilState(counterSaleManagementValueState);
  const [bookingDataValue, setBookingDataValue] = useRecoilState(bookingDataValueState);
  //const [raFillingAccordionValidationValue, setRaFillingAccordionValidationValue] = useRecoilState(raFillingAccordionValidationState);
  const setRaFillingAccordionValidation = useSetRecoilState(raFillingAccordionValidationState);
  const [raDetail, setRaDetail] = useRecoilState(raDetailState);
  const appLanguage = useTranslation();


  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const handleOpenSaveDialog = () => setIsSaveDialogOpen(true);
  const handleCloseSaveDialog = () => setIsSaveDialogOpen(false);

  const [flagCounterSaveGetOn, setFlagCounterSaveGetOn] = useState<any>(null);
  const [flagUpdateDefaultFormValue, setFlagUpdateDefaultFormValue] = useState<boolean>(false);
  const [ntwOfferId, setNtwOfferId] = useState<string>(''); // flag che gestisce il salvataggio del ntwOfferId in localstorage
  const [bookingEntity, setBookingEntity] = useRecoilState(bookingDataValueState);
  const navigate = useNavigate();

  const locale = useMemo((): 'it-IT' | 'en-IN' | 'fr-FR' => {
    return getLocaleByLang(appLanguage.i18n.language);
  }, [appLanguage.i18n.language]);

  const [areas, setAreas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /////////////////////////////////////////////////////////////////////// USE EFFECT START

  useEffect(() => {
    raDetailQuery.refetch();
  }, []);

  const [isKeyless, isRce] = useMemo(() => {
    return [
      !!raDetail?.generalInfo?.keyless,
      !!raDetail?.rce,
    ]
  }, [raDetail]);

  //   useEffect(() => {
  // 	if (!!flagCounterSaveGetOn) {
  //           console.log('useEffect flagCounterSaveGetOn!' + flagCounterSaveGetOn);
  // 		invokeCounterSaleManagement(flagCounterSaveGetOn);
  // 	}

  // }, [flagCounterSaveGetOn]);

  useEffect(() => {

    if (!raFilling?.generalInfo?.pickupLocation?.code) {
      console.log('useEffect RaFilling STOPPED no code on raFilling: ' + raFilling);
      return;
    }

    //console.log('useEffect RaFilling: ' + raFilling);

    //console.log('useEffect RaFilling plateNumber: ' + raFilling.generalInfo.plateNumber);

    const acrissObj = findObjectByPlate(raFilling.generalInfo.plateNumber, listVehiclesReady ?? []);
    raFillingDataForm.setValue('vehicleDetails.plate', acrissObj);

    //console.log('useEffect RaFilling acrissObj: ' + acrissObj);
    handleChangePlate(null, acrissObj);

    // manage Ancillary Info
    bookedAncillariesInfo.remove();
    raFilling?.ancillariesInfo?.ancillaries?.forEach((elem: ICSAncillary, index: number) => {
      bookedAncillariesInfo.append(elem);
      raFillingDataForm.setValue(`ancillariesInfo.booked.${index}`, elem);
    });


    //console.log('useEffect RaFilling bookedAncillariesInfo: ' + bookedAncillariesInfo);

    counterSaleAncillariesInfo.remove();
    raFilling?.ancillariesInfo?.ancillariesAdded?.forEach((elem: any, index: number) => {
      counterSaleAncillariesInfo.append(elem);
      raFillingDataForm.setValue(`ancillariesInfo.counterSale.${index}`, elem);
    });
    //console.log('useEffect RaFilling bookedAncillariesInfo: ' + counterSaleAncillariesInfo);

    listVehiclesReadyToRentMutation
      .mutate({
        tenant: raFilling?.vehicle?.idTenant,
        "locations": [{
          id: raFilling?.generalInfo?.pickupLocation?.code,
          type: "LMS"
        }],
        "keyless": isKeyless,
        "rce": isRce,
        bookingId: bookingEntity?.bookingDetail?.idBooking,
      } as any);

    getMobilityStoreBySapIdMutation.mutate(
      raFilling?.generalInfo?.dmsIdentificationCode?.code
    );

    raFillingDataForm.setValue('keylessArea', raFilling?.keylessArea ?? null);

    // counterSaleManagementMutation.mutateAsync({idRentalAgreement: params.id})
    //     .then(counterSale => {
    //         setCounterSaleManagement({previous: counterSale, last: counterSale});
    //         console.log('TEST2 CounterSaleManagement: ' + JSON.stringify(counterSaleManagement));
    //     })

  }, [raFilling]);


  useEffect(() => {
    //console.log('useEffect listVehiclesReady: ' + listVehiclesReady);
    handleReset();
  }, [listVehiclesReady])


  useEffect(() => {
    if (
      !_.isEqual(
        counterSaleManagement.previous,
        counterSaleManagement.last
      ) &&
      !!counterSaleManagement.last &&
      !counterSaleManagementMutation.isLoading
    ) {
      //invokeCounterSaleManagement(flagCounterSaveGetOn);
      createPayloadForAncillaryUpdate();
    }

  }, [counterSaleManagement]);

  /////////////////////////////////////////////////////////////////////// USE EFFECT END


  const raDetailQuery = useQuery(
    ["raDetail", { idRentalAgreement: params.id }],
    () => fetchRaDetail({ idRentalAgreement: params.id }),
    {
      enabled: false,
      onSuccess: (data) => {

        //console.log("raDetailQuery data: " + JSON.stringify(data));

        //Needed for Ancillaries and init of value
        setRaDetail(data);

        //Needed for vehicle and maybe for update to BE
        setRaFilling(data);

        setRaFillingAccordionValidation({
          generalInfo: false,
          firstBillingOwnerInfo: false,
          secondBillingOwnerInfo: false,
          ancillariesInfo: false,
        });

        initAncillaries(data);    //TODO

      },
      onError: async (error: any) => {
        console.log("raDetailQuery Error: " + error);
        viewErrorMessage("customerData.message.error.tryLater");
      },
    }
  );

  /*
  const invokeCounterSaleManagement = async (payload: any) => {
    counterSaleManagementMutation.mutate(payload);
  };
  */

  //Retrive info about ancillaries
  const counterSaleManagementMutation = useMutation(
    findCounterSaleManagement,
    {
      onSuccess: (response: ICounterSale) => {

        //console.log("findCounterSaleManagement response: " + JSON.stringify(response));

        setCounterSaleManagement({
          previous: counterSaleManagement.last,
          last: response,
        });

      },
      onError: async (error: any) => {
        console.log("findCounterSaleManagement error: " + error);
        viewErrorMessage("customerData.message.error.tryLater");
      },
    }
  );


  const initAncillaries = (data: any) => {
    let ntwOfferId = "";
    let raNtwOfferIdLS = localStorage.getItem("raNtwOfferId");

    if (!!raNtwOfferIdLS) {
      raNtwOfferIdLS = JSON.parse(raNtwOfferIdLS);
      if (!!raNtwOfferIdLS?.[data.generalInfo.reservationNumber]) {
        ntwOfferId = raNtwOfferIdLS[data.generalInfo.reservationNumber];
      }
    }

    const eTollStr = String(raFillingDataForm.getValues('vehicleDetails.eToll') ?? "").trim();
		const hasEToll = eTollStr.length > 0;
		//console.log(hasEToll);
    data?.ancillariesInfo?.ancillaries.forEach((ancillary: ICSAncillary) => {
      if (ancillary.ancillaryCode === "ET" && !hasEToll) {
        //console.log("3 ET Ancillary found in manageAncillary function");
        ancillary.deselectable = false;
        ancillary.mileage = 0;
        ancillary.units = 0;
      }
    });

    data?.ancillariesInfo?.ancillariesAdded.forEach((ancillary: ICSAncillary) => {
      if (ancillary.ancillaryCode === "ET" && !hasEToll) {
        //console.log("3 ET Ancillary found in manageAncillary function");
        ancillary.deselectable = false;
        ancillary.mileage = 0;
        ancillary.units = 0;
      }
    });

    const payload = {
      idRentalAgreement: data.idRentalAgreement,
      upsell: false, //formValue.generalInfo.upSell === 'YES',
      selectedAcrissSipp: null, //selected,
      ntwOfferId: ntwOfferId,
      etollNumber: data.vehicle.etollEquipNumber || '',
      bookedAncillaryList: data.ancillariesInfo.ancillaries.map(
        (elem: any) => {
          return {
            ancillaryCode: elem.ancillaryCode,
            units: elem.ancillaryUnits,
            mileage: elem.ancillaryMileage,
            address: elem.address,
            ancillarySubType: elem.ancillarySubType,
          };
        }
      ),
      counterSaleAncillaryList: data.ancillariesInfo.ancillariesAdded.map(
        (elem: any) => {
          return {
            ancillaryCode: elem.ancillaryCode,
            units: elem.ancillaryUnits,
            mileage: elem.ancillaryMileage,
            address: elem.address,
            ancillarySubType: elem.ancillarySubType,
          }
        }
      ),
      // counterSaleAncillaryList: [],
      init: 0,
    };

    setFlagCounterSaveGetOn(payload);
    setNtwOfferId(ntwOfferId);
    //invokeCounterSaleManagement(payload);
    setIsLoading(true);
    fetchCounterSaleManagement(payload).then((response) => {
      //console.log('LB CSM RESPONSE', response);
      const eTollStr = String(raFillingDataForm.getValues('vehicleDetails.eToll') ?? "").trim();
      const hasEToll = eTollStr.length > 0;
      //console.log(hasEToll);
      response?.counterSaleAncillaryList?.forEach((ancillary: ICSAncillary) => {
        if (ancillary.ancillaryCode === "ET" && !hasEToll) {
          //console.log("3 ET Ancillary found in manageAncillary function");
          ancillary.deselectable = false;
          ancillary.mileage = 0;
          ancillary.units = 0;
        }
      });
      setCounterSaleManagement({
        previous: counterSaleManagement.last,
        last: response,
      });
    }).catch((error) => {
      //viewErrorMessage("customerData.message.error.tryLater");
      viewErrorMessage(raFillingPricingErrorsManagement(error));
    }).finally(() => {
      setIsLoading(false);
    })
    //createPayloadForAncillaryUpdate();
  };

  const createPayloadForAncillaryUpdate = () => {
    const formValue = raFillingDataForm.getValues();
    const selected = buildSelectedAcrissSipp(formValue.vehicleDetails);

    const cs = deepClone(counterSaleManagement);

    const eTollStr = String(raFillingDataForm.getValues('vehicleDetails.eToll') ?? "").trim();
		const hasEToll = eTollStr.length > 0;
		//console.log(hasEToll);
    cs?.last?.counterSaleAncillaryList?.forEach((ancillary: ICSAncillary) => {
      if (ancillary.ancillaryCode === "ET" && !hasEToll) {
        //console.log("3 ET Ancillary found in manageAncillary function");
        ancillary.deselectable = false;
        ancillary.mileage = 0;
        ancillary.units = 0;
      }
    });

    const csM = {
      idRentalAgreement: raDetail.idRentalAgreement,
      upsell: raDetail.generalInfo.upSell,
      selectedAcrissSipp: selected,
      ntwOfferId: cs.last.ntwOfferId,
      bookedAncillaryList: cs.last.bookedAncillaryList.map((elem: any) => {
        return {
          ancillaryCode: elem.ancillaryCode,
          units: elem.units,
          mileage: elem.mileage,
          address: elem.address,
          ancillarySubType: elem.ancillarySubType || elem.subtype,
        };
      }),
      counterSaleAncillaryList: cs.last.counterSaleAncillaryList.map((elem: any, idx: any) => {
        const formCs = formValue.ancillariesInfo.counterSale
          .find((cs: any) => cs.ancillaryCode === elem.ancillaryCode)
          ?? formValue.ancillariesInfo.counterSale[idx];

        return {
          ancillaryCode: elem.ancillaryCode,
          units: formCs?.ancillaryUnits || 0,
          mileage: formCs?.ancillaryMileage || 0,
          address: elem.address,
          ancillarySubType: elem.ancillarySubType || elem.subtype
        }
      }),
      init: 0,
      etollNumber: formValue.vehicleDetails?.eToll || ''
    };

    //Update ancillaries?
    setIsLoading(true);
    fetchCounterSaleManagement(csM).then((response) => {
      const eTollStr = String(raFillingDataForm.getValues('vehicleDetails.eToll') ?? "").trim();
      const hasEToll = eTollStr.length > 0;
      //console.log(hasEToll);
      response?.counterSaleAncillaryList?.forEach((ancillary: ICSAncillary) => {
        if (ancillary.ancillaryCode === "ET" && !hasEToll) {
          //console.log("3 ET Ancillary found in manageAncillary function");
          ancillary.deselectable = false;
          ancillary.mileage = 0;
          ancillary.units = 0;
        }
      });
      setCounterSaleManagement({
        previous: counterSaleManagement.last,
        last: response,
      });
    }).catch((error) => {
      //viewErrorMessage("customerData.message.error.tryLater");
      viewErrorMessage(raFillingPricingErrorsManagement(error));
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const formResolver = useMemo(() => {
    if (isKeyless) {
      return yupResolver(
        RA_EDIT_FORM_VALIDATION_SCHEMA,
        {},
        { rawValues: true }
      )
    }

    return undefined
  }, [isKeyless]);

  const raFillingDataForm = useForm<IRaEditForm>({
    mode: 'onChange',
    resolver: formResolver,
  });

  const bookedAncillariesInfo = useFieldArray<IRaEditForm>({
    control: raFillingDataForm.control,
    name: "ancillariesInfo.booked"
  });

  const counterSaleAncillariesInfo = useFieldArray<IRaEditForm>({
    control: raFillingDataForm.control,
    name: "ancillariesInfo.counterSale"
  });

  const listVehiclesReadyToRentMutation = useMutation(
    listVehiclesReadyToRent,
    {
      onSuccess: (response: any) => {
        if (!response[0]?.vehicles) {
          setListVehiclesReady([]);
          return;
        }

        const list = response[0]?.vehicles?.map((elem: any) => {
          elem["fullDescription"] =
            elem.plate +
            " | " +
            elem.brandDescription +
            " | " +
            elem.modelDescription +
            " | " +
            elem.enginePowerGroupCode;
          return elem;
        });

        setListVehiclesReady(list);
        console.dir(list);
      },
      onError: async (error: any) => {
        viewErrorMessage("customerData.message.error.tryLater");
      },
    }
  );

  const getMobilityStoreBySapIdMutation = useMutation({
    mutationFn: (sapId: string) => getMobilityStoreBySapId(sapId),
    onSuccess: (data) => {
      setAreas(data);
    },
    onError: (error: AxiosError) => {
      console.error(error);
    }
  });

  /*
  const keylessAreaMutation = useMutation(

  )
  */


  const handleReset = (e?: React.SyntheticEvent) => {
    console.log('handleReset!');
    e?.stopPropagation();

    if (!listVehiclesReady) {
      raFillingDataForm.setValue('vehicleDetails.acriss', null);
      raFillingDataForm.setValue('vehicleDetails.sipp', null);
      raFillingDataForm.setValue('vehicleDetails.plate', null);
      handleChangeAcriss(e || null, null);
      setBrandModelDescr("");
    } else {
      const acrissObj = findObjectByPlate(raFilling.generalInfo.plateNumber, listVehiclesReady ?? []);
      raFillingDataForm.setValue('vehicleDetails.plate', acrissObj);
      handleChangePlate(null, acrissObj);
    }
  }

  const handleChangeAcriss = (event: null | React.SyntheticEvent, value: any) => {
    if (!!event) {
      event.stopPropagation();
    }

    if (!listVehiclesReady) {
      return;
    }

    raFillingDataForm.setValue('vehicleDetails.sipp', null);
    raFillingDataForm.setValue('vehicleDetails.plate', null);
    // setVehicleFormFields(null);
    const sco = Object.assign({}, selectionCarOptionList);

    if (sco.acriss.length === 0) {
      // @ts-ignore
      sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
        .map(elem => { return { code: elem.acrissCode, description: elem.acrissLabel } });
    }

    if (!value) {
      // @ts-ignore
      sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['sippCode'], item])).values()]
        .map(elem => {
          return {
            code: elem.sippCode,
            description: elem.sippLabel,
            acrissCode: elem.acrissCode,
            acrissLabel: elem.acrissLabel
          };
        });
      // @ts-ignore
      sco['plate'] = listVehiclesReady;
    }
    else {
      // @ts-ignore
      sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['acrissCode'] + item['sippCode'], item])).values()]
        .filter(elem => elem.acrissCode === value.code)
        .map(elem => {
          return {
            code: elem.sippCode,
            description: elem.sippLabel,
            acrissCode: elem.acrissCode,
            acrissLabel: elem.acrissLabel
          };
        });

      // @ts-ignore
      sco['plate'] = listVehiclesReady.filter(elem => elem.acrissCode === value.code);
    }
    setSelectionCarOptionList(sco);
  }

  const handleChangeSipp = (event: null | React.SyntheticEvent, value: any) => {
    if (!!event) {
      event.stopPropagation();
    }

    if (!listVehiclesReady) {
      return;
    }

    raFillingDataForm.setValue('vehicleDetails.plate', null);
    // setVehicleFormFields(null);

    const acrissCode = raFillingDataForm.getValues('vehicleDetails.acriss');

    const sco = Object.assign({}, selectionCarOptionList);

    if (sco.acriss.length === 0) {
      // @ts-ignore
      sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
        .map(elem => { return { code: elem.acrissCode, description: elem.acrissLabel } });
    }

    if (!value) {
      // @ts-ignore
      sco['plate'] = listVehiclesReady.filter((elem: any) => !acrissCode || elem.acrissCode === acrissCode.code);
    }
    else {
      if (!!value.code && !acrissCode) { // !null && null
        raFillingDataForm.setValue('vehicleDetails.acriss', { code: value.acrissCode, description: value.acrissLabel });
      }

      if (!!acrissCode) {
        sco['plate'] = listVehiclesReady.filter((elem: any) => acrissCode.code === elem.acrissCode && elem.sippCode === value.code);
      } else {
        sco['plate'] = listVehiclesReady.filter((elem: any) => elem.sippCode === value.code);
      }
    }
    setSelectionCarOptionList(sco);
  }

  const handleChangePlate = (event: React.SyntheticEvent | null, value: any) => {
    if (event !== null) {
      event.stopPropagation();
    }

    if (!listVehiclesReady) {
      return;
    }

    let acrissCode: any, sippCode: any;

    if (!!value) {
      raFillingDataForm.setValue('vehicleDetails.acriss', { code: value.acrissCode, description: value.acrissLabel });
      raFillingDataForm.setValue('vehicleDetails.sipp', { code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel });
      acrissCode = { code: value.acrissCode, description: value.acrissLabel };
      sippCode = { code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel };
    }
    else {
      acrissCode = raFillingDataForm.getValues('vehicleDetails.acriss');
      sippCode = raFillingDataForm.getValues('vehicleDetails.sipp');
    }

    const sco = Object.assign({}, selectionCarOptionList);

    if (sco.acriss.length === 0) {
      // @ts-ignore
      sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
        .map(elem => { return { code: elem.acrissCode, description: elem.acrissLabel } });
    }

    sco['plate'] = listVehiclesReady;
    if (!!acrissCode) {
      sco['plate'] = sco['plate'].filter((elem: any) => elem.acrissCode === acrissCode.code)
    }

    if (!!sippCode) {
      sco['plate'] = sco['plate'].filter((elem: any) => elem.sippCode === sippCode.code)
    }

    if (!!acrissCode) {
      // @ts-ignore
      sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['acrissCode'] + item['sippCode'], item])).values()]
        .filter((elem: any) => elem.acrissCode === acrissCode.code)
        .map(elem => {
          return {
            code: elem.sippCode,
            description: elem.sippLabel,
            acrissCode: elem.acrissCode,
            acrissLabel: elem.acrissLabel
          };
        });
    } else {
      // @ts-ignore
      sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['sippCode'], item])).values()]
        .map(elem => {
          return {
            code: elem.sippCode,
            description: elem.sippLabel,
            acrissCode: elem.acrissCode,
            acrissLabel: elem.acrissLabel
          };
        });
    }

    setSelectionCarOptionList(sco);

    // set form value
    setVehicleFormFields(value);

    setBrandModelDescr((!!value?.brandDescription ? value.brandDescription + ' ' : '') + (!!value?.modelDescription ? value.modelDescription : ''));

    if (!!counterSaleManagement?.last) {
      const csmClone = deepClone(counterSaleManagement.last);
      csmClone.selectedAcriss = { code: value?.acrissCode, description: value?.acrissLabel };
      setCounterSaleManagement({ previous: counterSaleManagement.last, last: csmClone });
    }

    setLoading(false);
  }

  function findObjectByPlate(input: any, arr: any) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].plate !== input) continue
      return arr[i]
    }
    return fromRaDetailToAcrissObj(raDetail);
  }


  const fromRaDetailToAcrissObj = (raDetail: any) => {
    let vehicle = raDetail.vehicle;
    let spaceDesc = ' | '


    if (vehicle == null) {
      return null;
    }

    return {
      id: null,
      vin: vehicle.vin,
      plate: vehicle.plate.code,
      internalNumber: vehicle.internalNumber,
      enginePowerGroupCode: vehicle.enginePowerGroupCode,
      termicTankCapacity: vehicle.termicTankCapacity,
      electricTankCapacity: vehicle.electricTankCapacity,
      currentTermicTankFilling: vehicle.currentTermicTankFilling,
      currentElectricTankFilling: vehicle.currentElectricTankFilling,
      kms: vehicle.kilometersOnStart,
      carSegmentDescription: vehicle.carSegmentDescription,
      carClassDescription: vehicle.carClassDescription,
      acrissCode: vehicle.acrissId,
      acrissLabel: vehicle.acrissDescription,
      sippCode: vehicle.sippId,
      sippLabel: vehicle.sippDescription,
      rfidCardNumber: vehicle.rfidCardNumber,
      rfidCardStatus: vehicle.rfidCardStatus,
      etollEquipNumber: vehicle.etollEquipNumber,
      etollLinkDatetime: vehicle.etollLinkDatetime,
      modelDescription: vehicle.modelDescription,
      brandDescription: vehicle.brandDescription,
      carSegmentLevel: vehicle.carSegmentLevel,
      tenant: vehicle.tenant,
      keyless: vehicle.keyless,
      fullDescription: (vehicle.plate.code + spaceDesc + vehicle.brandDescription + spaceDesc + vehicle.modelDescription + spaceDesc + vehicle.enginePowerGroupCode)
    };
  }


  const setVehicleFormFields = (value: any) => {
    //console.log('setVehicleFormFields Start value: ' + value);

    if (raDetail == null) {
      console.log('setVehicleFormFields raDetail is NULL!');
      return;
    }


    if (value === null) {
      value = fromRaDetailToAcrissObj(raDetail);
      //console.log('setVehicleFormFields new value: ' + value);
      raFillingDataForm.setValue('vehicleDetails.acriss', { code: value.acrissCode, description: value.acrissLabel });
      raFillingDataForm.setValue('vehicleDetails.sipp', { code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel });
      raFillingDataForm.setValue('vehicleDetails.plate', { plate: { code: value.plate }, fullDescription: value.fullDescription });
    }


    raFillingDataForm.setValue('vehicleDetails.vehicleID', !!value?.vin ? value.vin : '');
    raFillingDataForm.setValue('vehicleDetails.kmOnStart', !!value?.kms ? value.kms : '');
    raFillingDataForm.setValue('vehicleDetails.tankLevelOnStart', !!value?.currentTermicTankFilling ? value.currentTermicTankFilling + '/8' : '');
    raFillingDataForm.setValue('vehicleDetails.batteryLevelOnStart', !!value?.currentElectricTankFilling ? value.currentElectricTankFilling + '%' : '');
    raFillingDataForm.setValue('vehicleDetails.enginePowerGroupCode', !!value?.enginePowerGroupCode ? value.enginePowerGroupCode : '');
    raFillingDataForm.setValue('vehicleDetails.rdfiCard', !!value?.rfidCardNumber ? value.rfidCardNumber : '');
    raFillingDataForm.setValue('vehicleDetails.eToll', !!value?.etollEquipmentNumber ? value.etollEquipmentNumber : '');
    raFillingDataForm.setValue('vehicleDetails.chargingCableDomesticType', !!value?.chargingCableDomesticType ? value.chargingCableDomesticType : '');
    raFillingDataForm.setValue('vehicleDetails.chargingCableType2', !!value?.chargingCableType2 ? value.chargingCableType2 : '');
    raFillingDataForm.setValue('vehicleDetails.carClassDescription', !!value?.carClassDescription ? value.carClassDescription : '');
    raFillingDataForm.setValue('vehicleDetails.carSegmentDescription', !!value?.carSegmentDescription ? value.carSegmentDescription : '');


    //raFillingDataForm.setValue('vehicleDetails.keyless', value?.keyless ? 'true' : 'false');
    //raFillingDataForm.setValue('vehicleDetails.keylessInfo', value?.keylessInfo ? value.keylessInfo : '');

    raFillingDataForm.setValue('vehicleDetails.keyless', raDetail?.generalInfo?.keyless ? 'true' : 'false');
    // raFillingDataForm.setValue('keylessArea.keyLessInfo', raDetail?.keylessArea?.keyLessInfo ?? '');

    console.log('setVehicleFormFields vehicleDetails: ' + raFillingDataForm.getValues('vehicleDetails'));
  }




  ////////////////////////////////////////////////////////////////////// UTILITY START


  const viewErrorMessage = (message: string, type = snackbarTypes.error) => {
    setLoading(false);
    dispatchGlobalData({
      type: 'SET_SNACKBAR',
      payload: {
        snackbar: {
          message: t(message),
          type: type,
          show: true,
          autoClose: true,
        }
      }
    });
  }


  const onFormError = (data: any) => {
    console.log('onFormError', data);
  }

  const onSubmit = (data: IRaEditForm) => {
    setLoading(true);
    handleCloseSaveDialog();
    //console.log("onSubmit data: " + data);
    //console.log("onSubmit raDetail: " + raDetail);

    const rre = data.vehicleDetails.plate;

    if (!rre) {
      console.log(data.vehicleDetails.plate, rre);
      viewErrorMessage("invalid plate");
      return;
    }

    //console.log("onSubmit rre: " + rre);

    if (rre.plate !== raDetail.generalInfo.plateNumber) {

      //console.log("onSubmit updateVehicle with new plate " + rre.plate);

      raEdit({
        keyless: isKeyless,
        rce: isRce,
        keylessInfo: data?.keylessArea?.id,
        idRentalAgreement: params.id,
        vehicle: {
          acrissId: rre.acrissCode,
          acrissDescription: rre.acrissLabel,
          sippId: rre.sippCode,
          sippDescription: rre.sippLabel,

          plate: {
            code: rre.plate,
            description: rre.plate,
            label: rre.plate,
          },

          kilometersOnStart: rre.kms,

          carClassDescription: rre.carClassDescription,
          carSegmentDescription: rre.carSegmentDescription,
          brandDescription: rre.brandDescription,
          modelDescription: rre.modelDescription,

          rfidCard: rre.rfidCardNumber,
          etollEquipNumber: rre.etollEquipNumber,

          currentTermicTankFilling: rre.currentTermicTankFilling,
          currentElectricTankFilling: rre.currentElectricTankFilling,

          termicTankCapacity: rre.termicTankCapacity,
          electricTankCapacity: rre.electricTankCapacity,

          internalNumber: rre.internalNumber,
          vin: rre.vin,
        },
      })
        .then((response: any) => {
          //window.location.reload();
          //console.log("onSubmit raEdit response: " + response);
          //checkAndUpdateAncillaries();
          returnToDetail();
        })
        .catch((err: any) => viewErrorMessage(err.toString()));
    } else {
      // try{
      //   console.log("onSubmit No vehicle Update!");
      //   checkAndUpdateAncillaries();
      // }catch(error: any){
      //   viewErrorMessage(error);
      // }

      raEdit({
        keyless: isKeyless,
        rce: isRce,
        keylessInfo: data?.keylessArea?.id,
        idRentalAgreement: params.id
      }).then((response: any) => {
        //console.log("createAncillariesFromCountSaleAndUpdate raEdit response: " + response);
        returnToDetail();
      }).catch((error: any) => {
        console.log("createAncillariesFromCountSaleAndUpdate raEdit error: " + error);
        viewErrorMessage(error);
      });
    }
  };

  const returnToDetail = () => {
    navigate(`/network/ra-detail/${raDetail.idRentalAgreement}`);
  }

  ////////////////////////////////////////////////////////////////////// UTILITY END

  return loading ? (
    <></>
  ) : (
    <>
      <SectionHeader
        title={t("raDetail.header.title")}
        subtitle={
          <Stack direction="row" alignItems="center" columnGap={3}>
            <Stack direction="row" alignItems="end" columnGap={1}>
              <Typography variant="bodyLarge">
                {t("raDetail.header.subtitle.idRentalAgreement")}
              </Typography>
              <Typography variant="bodyLarge">
                {raFilling?.idRentalAgreement}
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="end" columnGap={1}>
              <Typography variant="bodyLarge">
                {t("raDetail.header.subtitle.status")}
              </Typography>
              <Typography variant="bodyLarge">
                {raFilling?.generalInfo?.raState?.description}
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="end" columnGap={1}>
              <Typography variant="bodyLarge">
                {t("raDetail.header.subtitle.raOwner")}
              </Typography>
              <Typography variant="bodyLarge">
                {raFilling?.generalInfo?.raOwnerFirstName}{" "}
                {raFilling?.generalInfo?.raOwnerLastName}
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="end" columnGap={1}>
              <Typography variant="bodyLarge">
                {t("raDetail.header.subtitle.totalAmount")}
              </Typography>
              <Typography variant="bodyLarge">
                {formatCurrency(locale as LOCALES, raFilling?.quotationInfo?.totalAmountTaxIncluded)}
              </Typography>
            </Stack>
          </Stack>
        }
      />

      <br style={{ marginBottom: theme.spacing(1) }} />

      <FormProvider {...raFillingDataForm}>
        <div style={{ padding: theme.spacing(1) }}>
          <Typography variant={"bodyLarge"}>
            {t("raFilling.vehicleDetails.form.title")}
          </Typography>
        </div>

        <Box
          sx={{
            border: "1px solid",
            borderColor: theme.palette.neutral.light,
            borderRadius: 2,
            bgcolor: theme.palette.neutral.main,
            px: theme.spacing(1),
            pb: theme.spacing(1),
            mb: theme.spacing(1),
          }}
        >
          {/* Vehicle Filters*/}
          <Grid container columnSpacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormAutocomplete<IRaEditForm>
                name="vehicleDetails.acriss"
                label={t("raFilling.vehicleDetails.form.label.acriss")}
                fullWidth
                //@ts-ignore
                options={selectionCarOptionList.acriss}
                isOptionEqualToValue={(option, value) =>
                  option?.code === value?.code
                }
                getOptionLabel={(opt) => opt?.code + " - " + opt?.description}
                onChange={handleChangeAcriss || []}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormAutocomplete<IRaEditForm>
                name="vehicleDetails.sipp"
                label={t("raFilling.vehicleDetails.form.label.sipp")}
                fullWidth
                // @ts-ignore
                options={selectionCarOptionList.sipp}
                isOptionEqualToValue={(option, value) =>
                  option?.code === value?.code
                }
                getOptionLabel={(opt) =>
                  !!opt?.description
                    ? opt?.code + " - " + opt?.description
                    : "Sipp Less"
                }
                onChange={handleChangeSipp || []}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{
                px: theme.spacing(0),
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <FormAutocomplete<IRaEditForm>
                name="vehicleDetails.plate"
                label={t("raFilling.vehicleDetails.form.label.plateNumber")}
                fullWidth
                // @ts-ignore
                options={selectionCarOptionList.plate}
                isOptionEqualToValue={(option, value) =>
                  option?.plate === value?.plate
                }
                getOptionLabel={(opt) => opt?.fullDescription}
                onChange={handleChangePlate || []}
              />

              <Button
                color={"accent"}
                onClick={handleReset}
                sx={{ mx: theme.spacing(1), mb: theme.spacing(0.5) }}
              >
                {t("raFilling.vehicleDetails.button.reset")}
              </Button>
            </Grid>
          </Grid>
        </Box>

        <div style={{ padding: theme.spacing(1) }}>
          <Grid container columnSpacing={2}>
            <Grid
              container
              item
              xs={12}
              md={6}
              columnSpacing={2}
              sx={{ mb: "auto", display: "flex", alignItems: "flex-start" }}
            >
              <Grid item xs={12} sm={6}>
                <FormTextField<IRaEditForm>
                  name="vehicleDetails.vehicleID"
                  label={t("raFilling.vehicleDetails.form.label.vehicleID")}
                  control={raFillingDataForm.control}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={0} sm={6} />

              <Grid item xs={12} sm={6}>
                <FormTextField<IRaEditForm>
                  name="vehicleDetails.kmOnStart"
                  label={t("raFilling.vehicleDetails.form.label.kmOnStart")}
                  control={raFillingDataForm.control}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormTextField<IRaEditForm>
                  name="vehicleDetails.tankLevelOnStart"
                  label={t(
                    "raFilling.vehicleDetails.form.label.tankLevelOnStart"
                  )}
                  control={raFillingDataForm.control}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormTextField<IRaEditForm>
                  name="vehicleDetails.batteryLevelOnStart"
                  label={t(
                    "raFilling.vehicleDetails.form.label.batteryOnStart"
                  )}
                  control={raFillingDataForm.control}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormTextField<IRaEditForm>
                  name="vehicleDetails.rdfiCard"
                  label={t("raFilling.vehicleDetails.form.label.rdfiCard")}
                  control={raFillingDataForm.control}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormTextField<IRaEditForm>
                  name="vehicleDetails.eToll"
                  label={t("raFilling.vehicleDetails.form.label.eToll")}
                  control={raFillingDataForm.control}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormRadioGroup<IRaEditForm>
                  name="vehicleDetails.chargingCableType2"
                  label={t(
                    "raFilling.vehicleDetails.form.label.chargingCableType2"
                  )}
                >
                  <FormControlLabel
                    value="NO"
                    label={t("common.button.no")}
                    disabled
                    control={<Radio />}
                  />
                  <FormControlLabel
                    value="YES"
                    label={t("common.button.yes")}
                    disabled
                    control={<Radio />}
                  />
                </FormRadioGroup>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormRadioGroup<IRaEditForm>
                  name="vehicleDetails.chargingCableDomesticType"
                  label={t(
                    "raFilling.vehicleDetails.form.label.chargingCableDomesticType"
                  )}
                >
                  <FormControlLabel
                    value="NO"
                    label={t("common.button.no")}
                    disabled
                    control={<Radio />}
                  />
                  <FormControlLabel
                    value="YES"
                    label={t("common.button.yes")}
                    disabled
                    control={<Radio />}
                  />
                </FormRadioGroup>
              </Grid>

              <Grid item xs={6}>
                <FormRadioGroup<IRaEditForm>
                  name="vehicleDetails.specialConditions"
                  label={t(
                    "raFilling.vehicleDetails.form.label.specialConditions"
                  )}
                  readOnly
                >
                  <FormControlLabel
                    value="false"
                    label={t("common.button.no")}
                    disabled
                    control={<Radio />}
                  />
                  <FormControlLabel
                    value="true"
                    label={t("common.button.yes")}
                    disabled
                    control={<Radio />}
                  />
                </FormRadioGroup>
              </Grid>

              <Grid item xs={6}>
                <FormRadioGroup<IRaEditForm>
                  name="vehicleDetails.keyless"
                  label={t("raFilling.vehicleDetails.form.label.keyLess")}
                  control={raFillingDataForm.control}
                  readOnly
                >
                  <FormControlLabel
                    value="false"
                    label={t("common.button.no")}
                    disabled
                    control={<Radio />}
                  />
                  <FormControlLabel
                    value="true"
                    label={t("common.button.yes")}
                    disabled
                    control={<Radio />}
                  />
                </FormRadioGroup>
              </Grid>
              {
                /*
                <Grid item xs={6}>
                  <FormAutocomplete<IRaEditForm>
                    name="keylessInfo"
                    label={t("raFilling.generalInfo.form.label.keyLessInfo")}
                    control={raFillingDataForm.control}
                    options={
                      areas.map((area: any) => area.keyLessInfo)
                    }
                  />
                </Grid>
                */
              }
              {<Grid item xs={6}>
                <FormAutocomplete<IRaEditForm>
                  name="keylessArea"
                  label={t("raFilling.generalInfo.form.label.keyLessInfo")}
                  control={raFillingDataForm.control}
                  options={areas}
                  getOptionLabel={(opt: any) => opt?.keyLessInfo ?? ""}
                  isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                  disabled={!isKeyless}
                />
              </Grid>}
            </Grid>

            <Grid container item xs={12} md={6} columnSpacing={2}>
              <Grid item xs={12}>
                <img
                  src={"/images/network/Panda.png"}
                  className="img-width-100"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant={"body"}>{brandModelDescr}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </div>

        {/* <Box sx={{
                    border: '1px solid',
                    borderColor: theme.palette.neutral.light,
                    borderRadius: 2,
                    bgcolor: theme.palette.neutral.main,
                    px: theme.spacing(1),
                    pb: theme.spacing(1),
                    mb: theme.spacing(1),
                }}>
                    <Grid item xs={6}>
                        <FormTextField
                            name="keylessInfo"
                            label={t("raFilling.generalInfo.form.label.keyLessInfo")}
                        />
                    </Grid>
                </Box> */}

        {
          <AncillariesInfoTest />
        }

        <Grid item xs={12} sx={{ marginTop: theme.spacing(2) }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between" // Distribuisce i pulsanti ai margini opposti
            alignItems="center"
          >
            <Button variant="contained" onClick={returnToDetail}>
              {t("dmsDetail.keyless.infoTab.button.cancel")}
            </Button>

            <Button variant="contained" onClick={handleOpenSaveDialog}>
              {t("dmsDetail.keyless.infoTab.button.edit")}
            </Button>
          </Stack>
        </Grid>


        {/* <br style={{ paddingTop: "2rem" }} />
                <input type="checkbox" onChange={(e) => setShowDebugInfo(e.target.checked)} /><span>Debug Info</span>
                {showDebugInfo && <pre>{ JSON.stringify(raFilling, null, 2) }</pre>} */}
      </FormProvider>

      <Dialog
        open={isSaveDialogOpen}
        onClose={handleCloseSaveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("dmsDetail.keyless.infoTab.dialog.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("dmsDetail.keyless.infoTab.dialog.content")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseSaveDialog}
            variant={"outlined"}
            color={"accent"}
          >
            {t("dmsDetail.keyless.infoTab.dialog.action.cancel")}
          </Button>
          <Button
            onClick={raFillingDataForm.handleSubmit(onSubmit, onFormError)}
            autoFocus
          >
            {t("dmsDetail.keyless.infoTab.dialog.action.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomLoader loading={raDetailQuery.isLoading || isLoading} />
    </>
  );
}

export default EditRa;
